/**
 * useCurrentLocale — derive the active locale from the URL.
 * Since BrowserRouter has its basename set to /{locale}, useLocation() returns
 * the path WITHOUT the locale prefix. So we read window.location directly.
 */
import { DEFAULT_LOCALE, LOCALE_CODES } from "@/i18n";

export function getCurrentLocale() {
  if (typeof window === "undefined") return DEFAULT_LOCALE;
  try {
    const m = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
    if (m && LOCALE_CODES.includes(m[1]) && m[1] !== DEFAULT_LOCALE) {
      return m[1];
    }
  } catch (e) {
    /* ignore */
  }
  return DEFAULT_LOCALE;
}

export function useCurrentLocale() {
  return getCurrentLocale();
}
